/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {useThemeMode} from "@metronic/partials";
import {getCSS, getCSSVariableValue} from "@metronic/assets/ts/_utils";
import {moneyFormat, NumReplace} from "@utils/index";
import {ThemeModeComponent} from "@metronic/assets/ts/layout";

type Props = {
    className: string,
    data: {
        series?: { name: string, data: number[] }[]
        categories?: string[]
    }
}

const CardsChartWidget: React.FC<Props> = ({className, data}) => {
    const chartRef = useRef<HTMLDivElement | null>(null)
    const {mode} = useThemeMode()


    const refreshChart = () => {
        if (!chartRef.current) {
            return
        }

        const height = parseInt(getCSS(chartRef.current, 'height'))

        const chart = new ApexCharts(chartRef.current, getChartOptions(height, data))
        if (chart) {
            chart.render()
        }

        window.dispatchEvent(new Event('resize'))


        return chart
    }

    useEffect(() => {

        const chart = refreshChart()


        return () => {
            if (chart) {
                chart.destroy()
            }
        }
    }, [chartRef, mode])



    return (
        <div
            ref={chartRef}
            id='kt_charts_widget_8_chart'
            style={{height: '350px'}}
        />
    )
}

export {CardsChartWidget}

type IData = {
    series?: { name: string, data: number[] }[]
    categories?: string[]
}

function getChartOptions(height: number, data: IData): ApexOptions {
    let humoColor, uzcardColor;
    let lineColorsArr: Array<string> = []
    let bgColorsArr: Array<string> = []
    let series = data.series


    if (data.series != null) {
        if (data.series.length > 0 && data.series[0].name.toLowerCase().includes("uzcard")) {
            series = data.series.reverse()
        }
        series = series?.map(item => {
            return {...item, data: item.data.map(val => val / 100)}
        })
    }

    const currentMode = ThemeModeComponent.getMode()
    const categories = data?.categories||[]
    series?.forEach(item => {
        if (item.name.toLowerCase().includes("uzcard")) {
            uzcardColor = "#233C7E"
            lineColorsArr.push(uzcardColor)
            bgColorsArr.push("#F1FAFF")
        }
        if (item.name.toLowerCase().includes("general")) {
            lineColorsArr.push('#50CD89')
            bgColorsArr.push("#FFF5CC")
        }
        if (item.name.toLowerCase().includes("humo")) {
            humoColor = "#BEA645"
            lineColorsArr.push(humoColor)
            bgColorsArr.push("#FFF5CC")
        }
        if (item.name.toLowerCase().includes("visa")) {
            humoColor = "#F79E1B"
            lineColorsArr.push(humoColor)
            bgColorsArr.push("#FFF5CC")
        }
        if (item.name.toLowerCase().includes("master")) {
            humoColor = "#f70e1b"
            lineColorsArr.push(humoColor)
            bgColorsArr.push("#FFF5CC")
        }
        if (item.name.toLowerCase().includes("approved")) {
            lineColorsArr.push('#50CD89')
            bgColorsArr.push("#FFF5CC")
        }
        if (item.name.toLowerCase().includes("failed")) {
            lineColorsArr.push('#F1416C')
            bgColorsArr.push("#FFF5CC")
        }
        if (item.name.toLowerCase().includes("init")) {
            lineColorsArr.push('#3445E5')
            bgColorsArr.push("#FFF5CC")
        }
        if (item.name.includes("revert")) {
            lineColorsArr.push('#FFA621')
            bgColorsArr.push("#FFF5CC")
        }
    })


    return {
        chart: {
            id: (series||[]).join(','),
            zoom: {
                enabled: false,
                type: 'x',
                autoScaleYaxis: true,
                zoomedArea: {
                    fill: {
                        color: '#90CAF9',
                        opacity: 0.4
                    },
                    stroke: {
                        color: '#0D47A1',
                        opacity: 0.4,
                        width: 1
                    }
                }
            },
            defaultLocale: 'ru',
            locales: [{
                name: 'ru',
                options: {
                    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                    shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                    days: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
                    shortDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                }
            }, {
                name: 'uz',
                options: {
                    months: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr'],
                    shortMonths: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyu', 'Iyu', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'],
                    days: ['Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba', 'Yakshanba'],
                    shortDays: ['Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Sha', 'Yak'],
                }
            }],
            toolbar: {
                show: false,
                tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    download: false,
                    selection: false,
                    pan: false,
                    reset: false,
                },

            },
            height: 350,
            type: "area",
            stacked: false
        },
        dataLabels: {
            enabled: false
        },
        colors: lineColorsArr,
        series: series,
        stroke: {
            curve: "straight",
            width: [4, 4],
            colors: lineColorsArr
        },
        plotOptions: {
            bar: {
                columnWidth: "20%"
            }
        },
        xaxis: {
            categories: categories,
            type: "datetime",
            labels: {

                // datetimeFormatter: {
                //     year: 'yyyy',
                //     month: 'MMM \'yy',
                //     day: 'dd MMM',
                //     hour: 'HH:mm'
                // },
                style: {
                    colors: currentMode === 'light' ? "#000000" : "#fff"
                }
            },
            // tooltip: {
            //     enabled: false,
            // },
        },
        yaxis: [
            {
                axisBorder: {
                    show: true,
                    color: currentMode === 'light' ? "#000000" : "#fff"
                },
                labels: {
                    formatter: function (value) {
                        // return NumReplace(Math.round(value).toString());
                        const formattedVal = moneyFormat(Math.round(value).toString());
                        return formattedVal.toString();
                    },
                    style: {
                        colors: currentMode === 'light' ? "#000000" : "#fff"
                    }
                },
            },
        ],
        fill: {
            type: 'gradient',
            opacity: 1,
            colors: lineColorsArr
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val) {
                    return NumReplace(val.toString()) + " сум"
                },
            }
        },
        legend: {
            show: false,
            showForSingleSeries: true,
            horizontalAlign: "left",
            position: "top",
            offsetX: 40,
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
    }
}
